import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './components/lang/i18n'

// Import FontAwesome for icons
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Add FontAwesome icons to the library
library.add(fas)

const app = createApp(App)

// Use plugins
app.use(router)
app.use(i18n)

// Register global components
app.component('font-awesome-icon', FontAwesomeIcon)

// Fade-in on scroll: <div v-reveal> (optional delay in ms: v-reveal="100")
app.directive('reveal', {
  mounted(el, binding) {
    el.classList.add('reveal')
    if (binding.value) {
      el.style.transitionDelay = `${binding.value}ms`
    }
    if (!('IntersectionObserver' in window)) {
      el.classList.add('is-visible')
      return
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          el.classList.add('is-visible')
          observer.disconnect()
        }
      })
    }, { threshold: 0.15 })
    observer.observe(el)
    el._revealObserver = observer
  },
  unmounted(el) {
    if (el._revealObserver) {
      el._revealObserver.disconnect()
    }
  }
})

// Mount the app
app.mount('#app')
